module.exports = __webpack_public_path__ + "img/racecourse-turffontein-turf-standside-1400.b5a7071a.svg";